import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
  AddKeywordAction,
  KEYWORD_TYPES,
  EditKeywordAction,
  GetOneKeywordAction,
  GetAllKeywordsAction,
} from './keywordTypes';
import * as Actions from './keywordActions';
import { KeywordApi } from '../api/keywordApi';
import { KeywordGetResponse } from '../model/keywordModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

function* addKeywordSaga(add: AddKeywordAction) {
  try {
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.LOADING));

    yield call(KeywordApi.post, add.payload.keyword);

    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.SUCCEEDED_ADD));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiKeywordRequestError(error.response.data.detail));
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* editKeywordSaga(edit: EditKeywordAction) {
  try {
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.LOADING));

    yield call(KeywordApi.put, edit.payload.params, edit.payload.keyword);

    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.SUCCEEDED_EDIT));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiKeywordRequestError(error.response.data.detail));
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getAllKeywordsSaga(getAll: GetAllKeywordsAction) {
  try {
    yield put(Actions.setApiKeywordsRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<KeywordGetResponse[]> = yield call(KeywordApi.getAll, getAll.payload.keywordFilter);

    yield put(Actions.setApiKeywordsRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getAllKeywordsSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiKeywordsRequestError(error.response.data.detail));
    yield put(Actions.setApiKeywordsRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getOneKeywordSaga(getOne: GetOneKeywordAction) {
  try {
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<KeywordGetResponse> = yield call(KeywordApi.getOne, getOne.payload.params);

    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getOneKeywordSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiKeywordRequestError(error.response.data.detail));
    yield put(Actions.setApiKeywordRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(KEYWORD_TYPES.ADD, addKeywordSaga),
    takeLatest(KEYWORD_TYPES.EDIT, editKeywordSaga),
    takeLatest(KEYWORD_TYPES.GET_ALL, getAllKeywordsSaga),
    takeLatest(KEYWORD_TYPES.GET_ONE, getOneKeywordSaga),
  ];
}
